import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { toExcelFormat } from '../../../helpers/format-position';
import { PickingPosition } from 'src/models/PickingProducts';

@Component({
  selector: 'app-product-picking-table-item',
  templateUrl: './product-picking-table-item.component.html',
  styleUrls: ['./product-picking-table-item.component.scss']
})
export class ProductPickingTableItemComponent implements OnInit {
  @Input() item: {
    name: string;
    sku: string;
    quantity: number;
    description?: string;
    pickingPositions: Array<{
      id: string;
      groundPosition: { x: number; y: number; alias?: string };
      createdAt?: number;
      updatedAt?: number;
    }>;
    position?: PickingPosition;
  };
  @Input() @HostBinding('class.isOdd') isOdd;
  formattedPosition: string;

  constructor() { }

  ngOnInit(): void {
    this.formattedPosition = this.formatPosition(this.item?.position);
  }

  formatPosition(position): string {
    if (position?.alias) {
      return position?.alias;
    } else {
      return toExcelFormat(position?.x, position?.y);
    }
  }

}
